import { pipe, keys, map, filter, sortBy, reduce, addIndex, append } from "ramda"

import { L10n } from "../_params.js"

const reduceIndexed = addIndex(reduce)

// TODO: refactor it to initialization function that sets translations to some state object and i18n function that takes translation from it

export const string = (key, { __defaultText } = {}) =>
  App && App.Text && App.Text.get2(key, __defaultText)

export const toAst = (replaceParams, text) => {
  const keysWithIndexes = pipe(
    keys,
    map((key) => {
      return {
        key,
        value: replaceParams[key],
        index: text.indexOf(key),
      }
    }),
    filter((key) => key.index !== -1),
    sortBy((key) => key.index),
  )(replaceParams)

  if (keysWithIndexes.length === 0) {
    return [
      {
        type: L10n.nodeTypes.text,
        value: text,
      },
    ]
  }

  const reducedKeys = reduceIndexed(
    (accumulator, key, index, list) => {
      let { ast } = accumulator

      if (accumulator.index < key.index) {
        ast = append(
          {
            type: L10n.nodeTypes.text,
            value: text.slice(accumulator.index, key.index),
          },
          ast,
        )
      }

      ast = append(
        {
          type: L10n.nodeTypes.node,
          value: key.value,
        },
        ast,
      )

      let nextKey = key.index + key.key.length

      if (index === list.length - 1 && nextKey < text.length) {
        ast = append(
          {
            type: L10n.nodeTypes.text,
            value: text.slice(nextKey),
          },
          ast,
        )
        nextKey = text.length
      }

      return {
        index: nextKey,
        ast,
      }
    },
    {
      index: 0,
      ast: [],
    },
    keysWithIndexes,
  )

  return reducedKeys.ast
}
